import React from 'react';
import { aboutSections } from '../eiraa_mock';

const EiraaAbout = () => {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        {aboutSections.map((section, index) => (
          <div
            key={section.id}
            className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-12 items-center mb-24 last:mb-0`}
          >
            {/* Image */}
            <div className="flex-1">
              <div className="relative overflow-hidden rounded-2xl shadow-2xl group">
                <img
                  src={section.image}
                  alt={section.title}
                  className="w-full h-[500px] object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/40 to-transparent"></div>
              </div>
            </div>

            {/* Content */}
            <div className="flex-1 space-y-6">
              <div>
                <span className="text-amber-600 font-semibold text-sm uppercase tracking-wider">
                  {section.subtitle}
                </span>
                <h2 className="text-4xl md:text-5xl font-light text-slate-900 mt-3 mb-6">
                  {section.title}
                </h2>
              </div>
              <p className="text-lg text-gray-600 leading-relaxed">
                {section.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default EiraaAbout;